import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../../../services/endpoints/endpoints.service";

export const useUpdateChecklistItem = () => {
	const queryClient = useQueryClient();

	const mutateCacheElement = (oldData: any, variables: any) => {
		if (oldData) {
			const updatedData = oldData.map((checklist: any) => {
				if (checklist.id === variables.checkListId) {
					return {
						...checklist,
						items: checklist.items.map((item: any) =>
							item.id === variables.id
								? {
										...item,
										completed: variables.completed,
										isCompletedOverride:
											variables.completed !== item.completed
												? true
												: item.isCompletedOverride,
										applicable: variables.applicable,
										isApplicableOverride:
											variables.applicable !== item.applicable
												? true
												: item.isApplicableOverride,
									}
								: item
						),
					};
				}
				return checklist;
			});
			return updatedData;
		}
	};

	return useMutation({
		onMutate: (variables) => {
			queryClient.cancelQueries({
				queryKey: ["checklists", { patientId: variables.patientId }],
			});
			const previousData = queryClient.getQueryData([
				"checklists",
				{ patientId: variables.patientId },
			]);
			queryClient.setQueryData(
				["checklists", { patientId: variables.patientId }],
				(oldData: any) => {
					return mutateCacheElement(oldData, variables);
				}
			);
			return previousData;
		},
		onError: (error, variables, context) => {
			console.error("Error updating checklist item:", error);
			queryClient.setQueryData(["checklists", { patientId: variables?.patientId }], context);
		},
		onSettled: (_data, _error, variables) => {
			queryClient.invalidateQueries({
				queryKey: ["checklists", { patientId: variables.patientId }],
			});
		},
		mutationFn: async ({
			id,
			checkListId: checklistId,
			patientId,
			applicable,
			isApplicableOverride,
			completed,
			isCompletedOverride,
		}: {
			id: number;
			checkListId: number;
			patientId: number;
			applicable: boolean;
			isApplicableOverride: boolean;
			completed: boolean;
			isCompletedOverride: boolean;
		}) => {
			await EndpointsService.dataRetriever.updateChecklistItem({
				checkListId: checklistId,
				body: {
					checkListItemId: id,
					patientId,
					completed,
					isCompletedOverride: isCompletedOverride,
					applicable,
					isApplicableOverride: isApplicableOverride,
				},
				config: {
					params: {
						patientId,
					},
				},
			});
		},
	});
};
